import { AUTHORIZATION_HEADER } from '../../../src/authorization';
import { send } from '../../../src/network';

export type SaveShippingDayResponse = unknown;

export interface PostSaveShippingDayPayload {
  order_id: string;
  selected_date: string;
}

export async function postSaveShippingDay(params: PostSaveShippingDayPayload) {
  return send<SaveShippingDayResponse>({
    path: `/api/save_shipping_day/`,
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
    body: params,
  });
}
